import * as React from 'react';
import { IApplicationSettingsListProps } from './StoreFrontSettings.interfaces';
import './_styles.scss';

const ApplicationSettingsList = (props: IApplicationSettingsListProps) => (
  <div className="application-settings-list">{props.children}</div>
);

export default ApplicationSettingsList;
